import { ScientificAreaType } from "../../../types/ScientificAreas";
import { put } from "../../../utils/axios-config";
import { SCIENTIFICAREAS } from "../../../utils/constants";

export const updateScientificArea = async (data:ScientificAreaType) => {
    return await put<ScientificAreaType, string>(SCIENTIFICAREAS, data);
};